export default __webpack_public_path__ + "static/media/5.c33e8b86.mp4";